import { RoleType } from "./AuthInterface";
import { tabs } from "./createJobTabs";
import { IPipeline } from "./pipelineInterface";
import { automatedActionStatus } from "./settingsInterface";
export interface IHiringStage {
    id: number;
    name: tabs;
    count: string;
    globalstagetypeid: GlobalStageTypesId,
    locked: boolean
}

export enum GlobalStageTypesId {
    candidates = 1,
    shortlist,
    assessment,
    interview,
    offer,
    hired,
    rejected,
}

export interface IPipelineStage {
    id: number,
    pipelineId: number,
    name: string,
    companyStageTypeId: number,
    isLocked: boolean,
    order: number,
    companyStageType: {
        id: number,
        companyId: number,
        name: string,
        globalStageTypeId: GlobalStageTypesId,
        order: number,
        isLocked: boolean,
    }
}

export interface IFormAnswer {
    id: string,
    typeId: number,
    key: string,
    answer: string
}

export interface ICandidate {
    id: number
    firstName: string
    lastName: string
    email: string
    phone: number
    cv: string
    coverLetter: string | null
    cvScore: number | null
    cvSummary: string | null
    longSummary: string | null
    comments: []
    pipelineStages: IPipeline[]
    pipelineHiringStageId: number,
    previousStageId: number,
    numberOfComments: number,
    jobId: number,
    interviewQuestions: string[]
    strengths: string[],
    weaknesses: string[],
    applicationCriteriasEvaluation: ICriteria[],
    batchId: number,
    isSimilar: boolean,
    cvFileName: string,
    userRole: { roleName: string }
    department?: {
        companyId: number,
        createdAt: string,
        id: number,
        name: string,
        parentDepartment?: {
            name: string,
        }
    }
    pipelineStage: IPipelineStage,
    hasKit: boolean,
    canEvaluate: boolean,
    allowAiInterview: boolean,
    formAnswers: IFormAnswer[]
}
export interface ICriteria {
    applicationId: number
    id: number
    jobCriteria: {
        criteriaName: string
        id: number
        isMain: boolean
        jobId: number
    }
    jobCriteriaId: number
    score: string
    summary: string,
    longSummary: string | null,
}

export interface ICandidatesFilter {
    page: number,
    perPage: number,
    sortBy: string,
    hiringStageId: number
}
export const candidatesSorting = [
    {
        value: 'highestScore',
        label: 'Highest Score'
    },
    {
        value: 'firstApplied',
        label: 'First Applied'
    },
    {
        value: 'lastApplied',
        label: 'Last Applied'
    },
    {
        value: 'az',
        label: 'A to Z'
    },
    {
        value: 'za',
        label: 'Z to A'
    }

]
export const SearchCandidatesSorting = [
    {
        value: 'highestScore',
        label: 'Highest Score'
    },
    {
        value: 'firstApplied',
        label: 'First Applied'
    },
    {
        value: 'lastApplied',
        label: 'Last Applied'
    },
    {
        value: 'az',
        label: 'A to Z'
    },
    {
        value: 'za',
        label: 'Z to A'
    },
    {
        value: 'bestMatch',
        label: 'Best Match'
    },
]
export interface IHiringStageModi {
    label: string;
    key: number;
    disabled: boolean,
    danger?: boolean
}

export interface IChangeCandidateStage {
    applicationId: number;
    hiringStageId: number;
}

export interface IInvitationData {
    email: string,
    roleId: number,
    objectId: number, // in case job >> objectId will be jobId , in case company  >> objectId will be companyId
    ObjectType: RoleType,
    isTopLevel: boolean,
    id: number
}

export interface IUpdateUserRoleBody {
    userId: number,
    roleId: number,
    objectId: number
    objectType: RoleType
}

export enum currentTypes {
    CV = "CV",
    coverLetter = "COVER_LETTER",
    Graph = "GRAPH"
}
export interface IAiSearchBody {
    jobId: string | undefined,
    hiringStageId: number,
    query: string,
    searchMethodId: number,
    perPage?: number,
    page?: number
}

export interface ISearchParams {
    jobsIds?: number[] | undefined,
    pipelineHiringStageIds?: number[],
    searchQuery?: string,
    sortBy?: string,
    perPage?: number,
    page?: number,
    departmentIds?: string
}
export interface IAIFilter {
    searchMethodId: number,
    page: number,
    perPage: number,
}

export interface IAutomatedNotification {
    id: number,
    status: automatedActionStatus,
    statusId?: number
    statusReason: string,
    leftTime: number,
}
export interface ISearchFilter {
    key: string,
    label: string
}
export interface ISearchCandidate {
    id: number;
    firstName: string;
    lastName: string;
    name: string;
    currentPosition: string;
    email: string;
    pipelineHiringStageId: number;
    snippet?: string;
    createdAt?: string;
    title: string;
    jobId: number
    stageName: string;
    cvFileName: string;
    batchId?: string;
    userRole: { roleName: string };
    department?: {
        companyId?: number,
        createdAt: string,
        id: number,
        name: string,
        parentDepartmentId: number,
        parentDepartment: {
            name: string
        }
    }
    isSimilar?: boolean;
    similarityTypes?: string[];
    phone?: string
    pipelineStage?: IPipelineStage
    cvScore: number
}

export interface IChangeCandidateJobBody {
    currentJobId: number,
    newJobId: number,
    pipelineStageId: number,
    applicationId: number
}
export interface ISearchCandidateSFilter {
    page: number,
    perPage: number,
    sortBy: string
}

export const perviousCandidateIndex = 2;

export interface ICandidateNavigation {
    id: number,
    jobId: number
}

export interface ICandidateAction {
    id: number,
    jobId: number,
    userRole: { roleName: string },
    pipelineStage: IPipelineStage,
    email: string
}

export interface IRejectionReason {
    id: number,
    reason: string,
}
